import { useQuery } from '@tanstack/react-query';
import type { CustomerSlaBreakdownResponse } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

export function useReadRateSlaByCustomer() {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['read-rate-sla', 'by-customer'],
    queryFn: () => apiClient.get<CustomerSlaBreakdownResponse>('read-rate-sla/by-customer'),
  });
}
